// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grammar-directory-page[data-v-0d6900f7]{max-width:1445px;background:#fff;min-height:550px;padding:20px 15px}.page-top[data-v-0d6900f7]{margin:10px 0 20px}.text-left[data-v-0d6900f7]{font-size:1.5rem}", ""]);
// Exports
module.exports = exports;
